<template>
    <van-popup v-model.sync="purchaseDetailDialog"
               :style="{ width: '100%',height: '100%' }">
        <div class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleClickPurchaseDetailCancel"></ReturnNavBar>
            </div>
            <div v-loading="loading" class="detail_wrap_container">
                <div class="m_page_little_title">
                    <span class="title">基本信息</span>
                </div>
                <van-form ref="purchaseForm"
                          error-message-align="right"
                          input-align="right"
                          label-width="10em"
                          scroll-to-error>
                    <div class="detail_chunk_wrap">
                        <ul class="purchase_table_list">
                            <li v-for="(item,index) in purchaseForm.purchase_details" class="purchase_details_item">
                                <div class="purchase_details_item_index">
                                    <span v-text="'代采' + (index+1)"></span>
                                </div>
                                <div class="purchase_details_item_content">
                                    <van-form input-align="right"
                                              label-width="12em"
                                              size="small">
                                        <van-field :value="item.supplier"
                                                   name="supplier"
                                                   label="供应商（个人或公司名称）"
                                                   maxlength="521"
                                                   placeholder="请输入供应商名称">
                                        </van-field>
                                        <ul class="goods_details_list">
                                            <li v-for="(goods,goods_index) in item.goods_details"
                                                class="goods_details_item">
                                                <div class="goods_details_index">
                                                    <span v-text="'产品明细' + (goods_index+1)"></span>
                                                    <span v-if="item.goods_details.length>1"
                                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="item.goods_details.splice(goods_index,1)">
                                                                <i class="el-icon-remove"></i>
                                                            </span>
                                                </div>
                                                <div class="goods_details_content">
                                                    <van-form error-message-align="right"
                                                              input-align="right"
                                                              label-width="4em">
                                                        <van-field :value="goods.goods_name"
                                                                   name="goods_name"
                                                                   label="产品名称"
                                                                   placeholder="请输入产品名称"
                                                                   readonly>
                                                        </van-field>
                                                        <van-field :value="goods.price"
                                                                   name="price"
                                                                   label="单价"
                                                                   placeholder="请输入单价"
                                                                   readonly>
                                                        </van-field>
                                                        <van-field :value="goods.num"
                                                                   name="num"
                                                                   label="数量"
                                                                   placeholder="请输入单价">
                                                        </van-field>
                                                        <van-field :value="goods.subtotal_price"
                                                                   name="subtotal_price"
                                                                   label="产品总价"
                                                                   placeholder="自动算出">
                                                        </van-field>
                                                    </van-form>
                                                </div>
                                            </li>
                                        </ul>
                                    </van-form>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <van-field :value="purchaseForm.total_price"
                               disabled
                               label="代采产品总金额"
                               name="total_price"
                               placeholder="自动算出">
                    </van-field>
                    <van-field :value="purchaseForm.discount_price"
                               label="总优惠金额"
                               name="discount_price"
                               placeholder="请输入总优惠金额"
                               readonly>
                    </van-field>
                    <van-field :value="purchaseForm.actual_total_price"
                               placeholder="自动算出"
                               label="实际代采总金额"
                               name="actual_total_price"
                               readonly>
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field :value="purchaseForm.remark||'--'"
                                   readonly
                                   autosize
                                   label="备注"
                                   name="remark"
                                   type="textarea">
                        </van-field>
                    </div>
                    <div class="vertical_input_wrap">
                        <van-field label="附件"
                                   name="file"
                                   readonly>
                            <template #input>
                                <div class="m_file_outer_wrap">
                                    <ul v-if="purchaseForm.file.length" class="m_upload_file_list">
                                        <li v-for="(file,file_idx) in purchaseForm.file"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载"
                                                            effect="dark"
                                                            placement="top">
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="handleClickDownloadFile(file)">
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-else>--</div>
                                </div>
                            </template>
                        </van-field>
                    </div>
                </van-form>
                <div v-if="purchaseForm.order_price_change.length">
                    <div class="m_page_little_title">
                        <span class="title">订单金额变更信息</span>
                    </div>
                    <div class="detail_chunk_wrap">
                        <ul class="order_price_change_list">
                            <li v-for="item in purchaseForm.order_price_change"
                                class="order_price_change_item flex_wrap">
                                <div class="field_name" v-text="item.field_name+'：'"></div>
                                <div>
                                    <span class="value_text"
                                          v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                                    <i class="iconfont icon-youjiantou"></i>
                                    <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </div>
    </van-popup>
</template>
<script>
import {purchaseDetails} from "@/api/index.js"
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "OrderPurchaseDetail",
    components: {
        ReturnNavBar
    },
    props: {
        purchaseDetailDialog: {
            type: Boolean,
            default: false
        },
        orderPurchaseId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: false,
            purchaseForm: {
                total_price: '',
                actual_total_price: '',
                discount_price: '',
                remarks: '',
                file: [],
                purchase_details: [
                    {
                        supplier: '',
                        goods_details: [
                            {
                                goods_name: '',
                                price: '',
                                num: undefined,
                                subtotal_price: ''
                            }
                        ],
                        total_amount: ''
                    }
                ],
                order_price_change: [],
                node_list: []
            },
            previewImgList: [],
            previewImgSrc: ''
        }
    },
    created() {
        if (this.orderPurchaseId) {
            this.getPurchaseDetail()
        }
    },
    methods: {
        //点击代采详情
        getPurchaseDetail() {
            this.loading = true
            purchaseDetails({
                order_purchase_id: this.orderPurchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseForm.total_price = res.data.total_price
                    this.purchaseForm.actual_total_price = res.data.actual_total_price
                    this.purchaseForm.discount_price = res.data.discount_price
                    this.purchaseForm.remarks = res.data.remarks
                    this.purchaseForm.file = res.data.file
                    this.purchaseForm.purchase_details = res.data.purchase_details
                }
                this.loading = false
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        //点击关闭代采详情
        handleClickPurchaseDetailCancel() {
            this.$emit("update:purchaseDetailDialog", false)
        },
    }
}
</script>
<style lang="scss" scoped>
.goods_details_content {
    padding: 8px !important;
}

.order_price_change_list {
    margin-bottom: 0;

    .order_price_change_item {
        .field_name {
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.purchase_details_item_content {
    .van-cell {
        padding: 10px 0;
    }
}
</style>
